import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { de } from "./locales/de";
import { en } from "./locales/en";

export const SUPPORTED_LANGS = ["de", "en"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

const NS = Object.keys(de) as (keyof typeof de)[];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { de, en } as unknown as Record<string, Record<string, object>>,
    fallbackLng: "de",
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    nonExplicitSupportedLngs: true,
    ns: NS as unknown as string[],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "cero-lang",
      lookupCookie: "cero-lang",
      cookieMinutes: 60 * 24 * 365,
    },
    returnNull: false,
    returnObjects: true,
  });

if (typeof document !== "undefined") {
  const apply = (lng: string) => {
    document.documentElement.lang = lng.startsWith("en") ? "en" : "de";
  };
  apply(i18n.language || "de");
  i18n.on("languageChanged", apply);
}

export default i18n;
